export default __webpack_public_path__ + "static/media/eggs.1905aa2f.png";